/**
 * NotFoundPage — Page 404
 */

import { Link } from 'react-router-dom';
import { colors } from '../styles/tokens.js';

export function NotFoundPage() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', textAlign: 'center' }}>
      <div style={{ fontSize: '4rem', fontWeight: 700, color: colors.accent, marginBottom: 16 }}>404</div>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 600, color: '#1a1a1a', marginBottom: 8 }}>
        Page introuvable
      </h1>
      <p style={{ fontSize: 14, color: '#666', marginBottom: 24 }}>
        La page que vous recherchez n'existe pas ou a été déplacée.
      </p>
      <Link
        to="/dashboard"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '10px 20px',
          borderRadius: 6,
          background: colors.accent,
          color: '#1a1a1a',
          fontWeight: 600,
          fontSize: '0.9rem',
          textDecoration: 'none',
          fontFamily: 'inherit',
        }}
      >
        <i className="bi bi-house-door" />
        Retour au tableau de bord
      </Link>
    </div>
  );
}
